import apiClient from '@api/apiClient';

const getSystems = async () => {
  try {
    const response = await apiClient.get('systems', {middleware: {withAuth: true}});
    const {data} = response || {};
    if (data) {
      return data;
    }
    return [];
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const getSystemUsers = async system_id => {
  try {
    const config = {
      middleware: {withAuth: true},
    };
    const response = await apiClient.get(`snapshots/systems/${system_id}/users`, config);
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const updateSystemUsers = async (system_id, users) => {
  try {
    const response = await apiClient.patch(
      `systems/${system_id}/users`,
      {users: users},
      {
        middleware: {withAuth: true},
      },
    );
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const getSystemSnapshot = async (system_id, snapshot_id) => {
  try {
    const config = {
      middleware: {withAuth: true},
    };
    if (snapshot_id !== undefined && snapshot_id !== null) {
      config.params = {snapshot_id};
    }
    const response = await apiClient.get(`snapshots/systems/${system_id}`, config);
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const getSystemSnapshotsRange = async (
  system_id,
  before_snapshot_id,
  after_snapshot_id,
) => {
  try {
    const response = await apiClient.get(
      `snapshots/systems/${system_id}/range?before_snapshot_id=${before_snapshot_id}&after_snapshot_id=${after_snapshot_id}`,
      {
        middleware: {withAuth: true},
      },
    );
    const {data} = response || {};
    return data;
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const addSystem = async (name, system_admin_id) => {
  try {
    const jsonData = {
      name: name,
      system_admin_id: system_admin_id,
    };
    const response = await apiClient.post('systems', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const editSystem = async (name, system_admin_id, system_id) => {
  try {
    const jsonData = {
      name: name,
      system_admin_id: system_admin_id,
    };
    const response = await apiClient.put(`systems/${system_id}`, jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const deleteSystem = async system_id => {
  try {
    const response = await apiClient.delete(`systems/${system_id}`, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const addSubsystem = async (system_id, name, users) => {
  try {
    const jsonData = {
      name: name,
      system_id: system_id,
      users: users,
    };
    const response = await apiClient.post('subsystems/create', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const editSubsystem = async (subsystem_id, name, users) => {
  try {
    const jsonData = {
      name: name,
      id: subsystem_id,
      users: users,
    };
    const response = await apiClient.post('subsystems/update', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const deleteSubsystem = async subsystem_id => {
  try {
    const response = await apiClient.delete(`subsystems/${subsystem_id}`, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const addModule = async (subsystem_id, name, test_types_ids) => {
  try {
    const jsonData = {
      name: name,
      subsystem_id: subsystem_id,
      test_types_ids: test_types_ids,
    };
    const response = await apiClient.post('modules/', jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const deleteModule = async module_id => {
  try {
    const response = await apiClient.delete(`modules/${module_id}`, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const editModule = async (module_id, name, delete_test_types_ids, add_test_types_ids) => {
  try {
    const jsonData = {
      name: name,
      delete_test_types_ids: delete_test_types_ids,
      add_test_types_ids: add_test_types_ids,
    };
    const response = await apiClient.patch(`modules/${module_id}`, jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const addCell = async ({
  coverage,
  auto_coverage,
  module_id,
  test_type_id,
  is_changeable,
}) => {
  try {
    const jsonData = {
      coverage,
      auto_coverage,
      module_id,
      test_type_id,
      is_changeable,
    };
    const response = await apiClient.post(`cells/add`, jsonData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const exportSystem = async ({system_id, exportData}) => {
  try {
    const response = await apiClient.post(`export/${system_id}`, exportData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    console.log(data);
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const getSystemNotificationSettings = async system_id => {
  try {
    const config = {
      middleware: {withAuth: true},
    };
    const response = await apiClient.get(`notifications/system/${system_id}`, config);
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const setSystemNotificationSettings = async (
  system_id,
  interval_type,
  notification_type,
) => {
  try {
    const response = await apiClient.put(
      `notifications/system/${system_id}`,
      {interval_type, notification_type},
      {
        middleware: {withAuth: true},
      },
    );
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const deleteSystemNotificationSettings = async system_id => {
  try {
    const response = await apiClient.delete(`notifications/system/${system_id}`, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

export const systemsAPI = {
  getSystems,
  getSystemUsers,
  updateSystemUsers,
  getSystemSnapshot,
  getSystemSnapshotsRange,
  addSystem,
  editSystem,
  deleteSystem,
  addSubsystem,
  editSubsystem,
  addModule,
  deleteSubsystem,
  deleteModule,
  editModule,
  addCell,
  exportSystem,
  getSystemNotificationSettings,
  setSystemNotificationSettings,
  deleteSystemNotificationSettings,
};
